var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.125 30.25C17.645 30.25 14 26.605 14 22.125C14 17.645 17.645 14 22.125 14C26.605 14 30.25 17.645 30.25 22.125C30.25 26.605 26.605 30.25 22.125 30.25ZM22.125 15.25C18.3337 15.25 15.25 18.335 15.25 22.125C15.25 25.915 18.3337 29 22.125 29C25.9163 29 29 25.915 29 22.125C29 18.335 25.9163 15.25 22.125 15.25Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 26.25C21.53 26.25 21.25 25.97 21.25 25.625V20.625C21.25 20.28 21.53 20 21.875 20C22.22 20 22.5 20.28 22.5 20.625V25.625C22.5 25.97 22.22 26.25 21.875 26.25Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 18.75C22.2202 18.75 22.5 18.4702 22.5 18.125C22.5 17.7798 22.2202 17.5 21.875 17.5C21.5298 17.5 21.25 17.7798 21.25 18.125C21.25 18.4702 21.5298 18.75 21.875 18.75Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 26.25H3.125C1.4025 26.25 0 24.8487 0 23.125V6.875C0 5.15125 1.4025 3.75 3.125 3.75H5.625C5.97 3.75 6.25 4.03 6.25 4.375C6.25 4.72 5.97 5 5.625 5H3.125C2.09125 5 1.25 5.84125 1.25 6.875V23.125C1.25 24.1587 2.09125 25 3.125 25H11.875C12.22 25 12.5 25.28 12.5 25.625C12.5 25.97 12.22 26.25 11.875 26.25Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 7.5H6.875C5.84125 7.5 5 6.65875 5 5.625V3.125C5 2.78 5.28 2.5 5.625 2.5H7.5625C7.85375 1.075 9.115 0 10.625 0C12.135 0 13.3962 1.075 13.6875 2.5H15.625C15.97 2.5 16.25 2.78 16.25 3.125V5.625C16.25 6.65875 15.4087 7.5 14.375 7.5ZM6.25 3.75V5.625C6.25 5.96875 6.53 6.25 6.875 6.25H14.375C14.72 6.25 15 5.96875 15 5.625V3.75H13.125C12.78 3.75 12.5 3.47 12.5 3.125C12.5 2.09125 11.6587 1.25 10.625 1.25C9.59125 1.25 8.75 2.09125 8.75 3.125C8.75 3.47 8.47 3.75 8.125 3.75H6.25Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 11.25H4.375C4.03 11.25 3.75 10.97 3.75 10.625C3.75 10.28 4.03 10 4.375 10H16.875C17.22 10 17.5 10.28 17.5 10.625C17.5 10.97 17.22 11.25 16.875 11.25Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 15H4.375C4.03 15 3.75 14.72 3.75 14.375C3.75 14.03 4.03 13.75 4.375 13.75H13.125C13.47 13.75 13.75 14.03 13.75 14.375C13.75 14.72 13.47 15 13.125 15Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 18.75H4.375C4.03 18.75 3.75 18.47 3.75 18.125C3.75 17.78 4.03 17.5 4.375 17.5H10.625C10.97 17.5 11.25 17.78 11.25 18.125C11.25 18.47 10.97 18.75 10.625 18.75Z",
    fill: "#333333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 11.25C20.28 11.25 20 10.97 20 10.625V6.875C20 5.84125 19.1588 5 18.125 5H15.625C15.28 5 15 4.72 15 4.375C15 4.03 15.28 3.75 15.625 3.75H18.125C19.8475 3.75 21.25 5.15125 21.25 6.875V10.625C21.25 10.97 20.97 11.25 20.625 11.25Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailIcon);
export default __webpack_public_path__ + "static/media/DetailIcon.9e7ec28daccf75d743ccf758b2be4b0c.svg";
export { ForwardRef as ReactComponent };